class Affix {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.affixOffset = this.offset(this.element).top ?? null;
    this.elHeight = this.element.offsetHeight;
    this.initEvents();
  }

  initEvents() {
    window.addEventListener("scroll", this.scroll.bind(this), { passive: true });
    window.addEventListener("resize", this.resize.bind(this), { passive: true });
  }

  resize(){
    if(window.outerWidth < 1201) {
      this.detach();
    }
  }

  scroll(ev) {
    if(window.outerWidth < 1201)
      return false;

    if(window.scrollY > this.affixOffset){
      this.affix();
    } else {
      this.detach();
    }
  }

  affix() {
    this.element.classList.add("affixed");
    this.element.nextElementSibling.style.marginTop = `${this.elHeight}px`;
  }

  detach () {
    this.element.classList.remove("affixed");
    this.element.nextElementSibling.style.marginTop = `0`;
  }

  offset(el) {
    const box = el.getBoundingClientRect();
    const docElem = document.documentElement;

    return {
      top: (box.top + window.pageYOffset - docElem.clientTop) + el.offsetHeight,
      left: (box.left + window.pageXOffset - docElem.clientLeft) +  + el.offsetWidth
    };
  }
}

export default Affix;
